import {
  ChangeDetectionStrategy,
  Component,
  Directive,
  HostBinding,
  Input,
} from '@angular/core';

@Component({
  selector: 'lui-toolbar',
  template: `
    <div class="lui-toolbar-container">
      <ng-content select="[luiToolbarActionsStart]"></ng-content>
      <ng-content select="[luiToolbarActionsEnd]"></ng-content>
      <div class="lui-toolbar-main">
        <ng-content></ng-content>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ToolBarComponent {
  @Input() actionsPositionSmall: 'top' | 'bottom' | 'inline' = 'top';

  @HostBinding('class.lui-toolbar-sticky') @Input() sticky = false;

  @HostBinding('class') hostClasses = ['lui-toolbar', 'zone-dark'];

  @HostBinding('class.lui-toolbar-actions-top') get actionsTopClass() {
    return this.actionsPositionSmall === 'top';
  }

  @HostBinding('class.lui-toolbar-actions-bottom') get actionsBottomClass() {
    return this.actionsPositionSmall === 'bottom';
  }

  @HostBinding('class.lui-toolbar-actions-inline') get actionsInlinceClass() {
    return this.actionsPositionSmall === 'inline';
  }
}

@Directive({
  selector: '[luiToolbarActionsStart]',
  standalone: false,
})
export class ToolbarActionsStartDirective {
  @HostBinding('class') hostClass = 'lui-toolbar-actions-start';
}

@Directive({
  selector: '[luiToolbarActionsEnd]',
  standalone: false,
})
export class ToolbarActionsEndDirective {
  @HostBinding('class') hostClass = 'lui-toolbar-actions-end';
}
